/*
  a11y.js: accessibility behaviour fixes, Oct 2026. Loaded from layout/theme.liquid.
  Adds attributes only; it does not change what any control does.
  To undo: delete this file and its <script> line in theme.liquid.
*/

// S27: header dropdowns. The theme opens a dropdown by adding .nav-hover to its <li>
// (on hover and on keyboard focus) but never tells assistive technology. Mirror that
// state onto the top-level link as aria-expanded, and mark the link as having a menu.
(function () {
  var items = document.querySelectorAll('#AccessibleNav > li.site-nav--has-dropdown');
  Array.prototype.forEach.call(items, function (item) {
    var link = item.querySelector(':scope > a');
    if (!link) return;
    link.setAttribute('aria-haspopup', 'true');
    var sync = function () {
      link.setAttribute('aria-expanded', item.classList.contains('nav-hover') ? 'true' : 'false');
    };
    sync();
    new MutationObserver(sync).observe(item, { attributes: true, attributeFilter: ['class'] });
  });
})();

// H25: the Flashquotes catering quote form is inserted by Flashquotes' own script with
// no title, so screen readers announce an unnamed frame. Name it once it appears.
(function () {
  var nameFrames = function () {
    var frames = document.querySelectorAll('iframe[src*="flashquotes.com"]:not([title])');
    Array.prototype.forEach.call(frames, function (frame) {
      frame.setAttribute('title', 'Catering quote request form');
    });
  };
  if (!document.querySelector('script[src*="flashquotes.com"]')) return;
  nameFrames();
  new MutationObserver(nameFrames).observe(document.body, { childList: true, subtree: true });
})();

// H20: Enter on a variant option (size, grind, etc.) submitted the product form, adding
// the item to the cart. Make Enter choose the option instead, like Space does.
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Enter') return;
  var input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
  if (!input.closest('.swatch-element')) return;
  event.preventDefault();
  if (!input.checked) input.click();
}, true);

// H21: keyboard focus in the cart drawer (also used for search and quick view) and the
// mobile menu. The theme opens them by adding js-drawer-open-right / js-drawer-open-left to
// <body>; it doesn't move focus in, keep it there, or bring it back. Watch those classes and
// do that, without changing how the drawers themselves open, close or update the cart.
(function () {
  var body = document.body;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var DRAWERS = {
    right: {
      openClass: 'js-drawer-open-right',
      find: function () { return document.querySelector('.drawer--right'); },
      label: function (el) {
        if (el.classList.contains('quick-view-drawer')) return 'Quick view';
        if (el.querySelector('input[type="search"]')) return 'Search';
        return 'Cart';
      },
      first: '.drawer__close button',
      triggers: '.js-drawer-open-right-link'
    },
    left: {
      openClass: 'js-drawer-open-left',
      find: function () { return document.getElementById('NavDrawer'); },
      label: function () { return 'Menu'; },
      first: '.mobile-menu--close-btn',
      triggers: '.js-drawer-open-left-link'
    }
  };
  var openState = { right: null, left: null }; // { opener } while open

  function focusables(el) {
    return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), function (n) {
      return n.getClientRects().length > 0 && !n.closest('[aria-hidden="true"]');
    });
  }

  function setTriggers(key, expanded) {
    Array.prototype.forEach.call(document.querySelectorAll(DRAWERS[key].triggers), function (t) {
      t.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function onOpen(key) {
    var d = DRAWERS[key];
    var opener = document.activeElement;
    openState[key] = { opener: opener && opener !== body ? opener : null };
    setTriggers(key, true);
    var tries = 0;
    (function whenRendered() {
      var el = d.find();
      if (!el && tries++ < 40) { setTimeout(whenRendered, 25); return; } // Vue renders the cart drawer just after the class change
      if (!el) return;
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', d.label(el));
      if (el.contains(document.activeElement)) return; // the theme already focused something inside (e.g. the search box)
      // At phone widths the theme strips tabindex from every link in the mobile menu, including
      // the close control below, so make it focusable again each time the menu opens.
      var navClose = el.querySelector('.mobile-menu--close-btn');
      if (navClose && !navClose.hasAttribute('href')) navClose.setAttribute('tabindex', '0');
      var target = el.querySelector(d.first) || focusables(el)[0];
      if (target) target.focus();
    })();
  }

  function onClose(key) {
    setTriggers(key, false);
    var s = openState[key];
    openState[key] = null;
    var back = s && s.opener && document.contains(s.opener) ? s.opener : document.querySelector(DRAWERS[key].triggers);
    if (back) back.focus();
  }

  new MutationObserver(function () {
    ['right', 'left'].forEach(function (key) {
      var isOpen = body.classList.contains(DRAWERS[key].openClass);
      if (isOpen && !openState[key]) onOpen(key);
      else if (!isOpen && openState[key]) onClose(key);
    });
  }).observe(body, { attributes: true, attributeFilter: ['class'] });

  // Keep Tab and Shift+Tab inside whichever drawer is open.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var key = openState.right ? 'right' : (openState.left ? 'left' : null);
    if (!key) return;
    var el = DRAWERS[key].find();
    if (!el) return;
    var items = focusables(el);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (!el.contains(document.activeElement)) { event.preventDefault(); first.focus(); return; }
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  // The mobile menu's close control is an <a> with no href, so a keyboard can't reach or press it.
  var navClose = document.querySelector('.mobile-menu--close-btn');
  if (navClose) {
    navClose.setAttribute('tabindex', '0');
    navClose.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); navClose.click(); }
    });
  }
})();
